import { jsxs, jsx } from 'react/jsx-runtime';
import styled from '@emotion/styled';
import { __rest } from 'tslib';

const Radio = (_a) => {
    var { name, checked, disabled, onChange, children } = _a, rest = __rest(_a, ["name", "checked", "disabled", "onChange", "children"]);
    return (jsxs(StyledWrapper, Object.assign({}, rest, { children: [jsxs(StyledRadio, { children: [jsx(StyledInput, { type: "radio", name: name, checked: checked, disabled: disabled, onChange: (e) => !disabled && onChange && onChange(e.target.checked), className: "teko-radio-input" }), jsx("div", { className: "checkmark" })] }), children] })));
};
const StyledWrapper = styled.div `
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const StyledRadio = styled.div(({ theme, disabled }) => `
display: inline-block;
position: relative;
width: 16px;
min-width: 16px;
height: 16px;
margin-right: 8px;

& input ~ .checkmark {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid ${theme.colors.border};
  border-radius: 50%;
  background-color: ${theme.colors.white};
  display: block;
}

& input:checked ~ .checkmark {
  border: 1px solid ${!disabled ? theme.colors.primary500 : theme.colors.disable};
  &::after {
    content: '';
    position: absolute;
    width: 50%;
    height: 50%;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    background-color: ${!disabled ? theme.colors.primary500 : theme.colors.primary100};
  }
}
`);
const StyledInput = styled.input(({ disabled, theme }) => `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: ${disabled ? 'not-allowed' : 'pointer'};
  opacity: 0;
  ${!disabled
    ? `
      &:hover + .checkmark {
        border-color: ${theme.colors.primary500};
      }
    `
    : ''}
`);

const RadioGroup = ({ options, inline = false, children, value, onChange, name, }) => {
    return (jsxs(Wrapper, Object.assign({ inline: inline }, { children: [options === null || options === void 0 ? void 0 : options.map((opt) => (jsx(Radio, Object.assign({ name: name }, (!name
                ? {
                    checked: value === opt.value,
                    onClick: () => onChange && onChange(opt.value),
                }
                : {}), { children: opt.label }), opt.value))), children] })));
};
const Wrapper = styled.div(({ inline }) => `
  display: flex;
  flex-direction: ${inline ? 'row' : 'column'};
  gap: 16px;
`);

export { RadioGroup as R, Radio as a };
